/** Built-in jewelry customization profiles (always available; admin can hide or extend). */

export const BUILTIN_JEWELRY_PROFILES = {
  locket_photo: {
    id: 'locket_photo',
    label: 'Photo locket / pendant',
    hint: 'Customer uploads a photo to embed inside the locket. Turn on chain length in product options if you sell it with a chain.',
    fields: [
      { id: 'photo', type: 'photo', label: 'Photo for locket', required: true, hint: 'Clear front-facing photo works best.' },
      {
        id: 'chain_length',
        type: 'select',
        label: 'Chain length',
        optional: true,
        adminLabel: 'Offer chain length',
        optionsKey: 'chain',
      },
      {
        id: 'note',
        type: 'text',
        label: 'Special instructions (optional)',
        optional: true,
        adminLabel: 'Special instructions field',
        maxLength: 200,
      },
    ],
  },
  pendant_chain: {
    id: 'pendant_chain',
    label: 'Pendant + chain length',
    hint: 'Customer picks chain length — no photo upload.',
    fields: [
      { id: 'chain_length', type: 'select', label: 'Chain length', required: true, optionsKey: 'chain' },
      {
        id: 'note',
        type: 'text',
        label: 'Notes (optional)',
        optional: true,
        adminLabel: 'Notes field',
        maxLength: 200,
      },
    ],
  },
  ring_size: {
    id: 'ring_size',
    label: 'Ring — pick size',
    fields: [
      { id: 'ring_size', type: 'select', label: 'Ring size', required: true, optionsKey: 'ring' },
      {
        id: 'engraving',
        type: 'text',
        label: 'Inside engraving (optional)',
        optional: true,
        adminLabel: 'Inside engraving field',
        maxLength: 24,
      },
    ],
  },
  bracelet_size: {
    id: 'bracelet_size',
    label: 'Bracelet / kada — pick size',
    fields: [
      { id: 'bracelet_size', type: 'select', label: 'Bracelet size', required: true, optionsKey: 'bracelet' },
      {
        id: 'engraving',
        type: 'text',
        label: 'Engraving (optional)',
        optional: true,
        adminLabel: 'Engraving field',
        maxLength: 24,
      },
    ],
  },
  photo_engraving: {
    id: 'photo_engraving',
    label: 'Photo + back engraving',
    fields: [
      { id: 'photo', type: 'photo', label: 'Photo', required: true },
      { id: 'engraving', type: 'text', label: 'Back engraving', required: true, maxLength: 30 },
      {
        id: 'chain_length',
        type: 'select',
        label: 'Chain length',
        optional: true,
        adminLabel: 'Offer chain length',
        optionsKey: 'chain',
      },
    ],
  },
  engraving_only: {
    id: 'engraving_only',
    label: 'Custom engraving text',
    fields: [
      { id: 'engraving', type: 'text', label: 'Engraving text', required: true, maxLength: 40 },
      {
        id: 'note',
        type: 'text',
        label: 'Font / placement notes (optional)',
        optional: true,
        adminLabel: 'Placement notes field',
        maxLength: 120,
      },
    ],
  },
};
